module.exports = __webpack_public_path__ + "img/hand.7eccb16b.svg";